(() => {
  const savedKey = 'fsp_vehicle_v1';
  const getJSON = (url) => {
    const requestUrl = new URL(url, location.origin);
    const direct = () => fetch(requestUrl.href, { cache: 'no-store', headers: { Accept: 'application/json' } }).then((r) => {
      if (!r.ok) throw new Error(String(r.status));
      return r.json();
    });
    if (!requestUrl.hostname.endsWith('.chatgpt.site')) return direct();
    return direct().catch(() => fetch(`https://r.jina.ai/${requestUrl.href}`, { cache: 'no-store' }).then(async (r) => {
      if (!r.ok) throw new Error(`Fitment fallback failed (${r.status})`);
      const text = await r.text();
      const marker = 'Markdown Content:';
      const start = text.indexOf(marker);
      if (start < 0) throw new Error('Fitment fallback returned an unexpected response');
      return JSON.parse(text.slice(start + marker.length).trim());
    }));
  };
  const enhanceSelect = (select) => {
    if (!select || select.dataset.customReady) return;
    select.dataset.customReady = 'true';
    select.classList.add('fsp-custom-select__native');
    const wrap = document.createElement('div');
    wrap.className = 'fsp-custom-select';
    select.parentNode.insertBefore(wrap, select);
    wrap.append(select);
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'fsp-custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');
    const menu = document.createElement('div');
    menu.className = 'fsp-custom-select__menu';
    menu.hidden = true;
    const search = document.createElement('input');
    search.type = 'search';
    search.className = 'fsp-custom-select__search';
    search.placeholder = `Search ${select.name === 'submodel' ? 'submodel' : select.name || 'options'}`;
    search.setAttribute('aria-label', search.placeholder);
    search.autocomplete = 'off';
    const options = document.createElement('div');
    options.className = 'fsp-custom-select__options';
    options.setAttribute('role', 'listbox');
    menu.append(search, options);
    wrap.append(trigger, menu);
    const close = () => {
      wrap.classList.remove('is-open');
      menu.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
      search.value = '';
    };
    const render = () => {
      const selected = select.options[select.selectedIndex];
      trigger.textContent = selected?.textContent || `Select ${select.name || 'option'}`;
      wrap.classList.toggle('is-disabled', select.disabled);
      trigger.disabled = select.disabled;
      const query = search.value.trim().toLowerCase();
      const matches = [...select.options].filter((option) => option.value && option.textContent.toLowerCase().includes(query));
      options.replaceChildren();
      if (!matches.length) {
        const empty = document.createElement('div');
        empty.className = 'fsp-custom-select__empty';
        empty.textContent = 'No matching options';
        options.append(empty);
        return;
      }
      matches.forEach((option) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'fsp-custom-select__option';
        button.setAttribute('role', 'option');
        button.setAttribute('aria-selected', String(option.selected));
        button.classList.toggle('is-selected', option.selected);
        button.textContent = option.textContent;
        button.addEventListener('click', () => {
          select.value = option.value;
          select.dispatchEvent(new Event('change', { bubbles: true }));
          close();
          trigger.focus();
        });
        options.append(button);
      });
    };
    trigger.addEventListener('click', () => {
      document.querySelectorAll('.fsp-custom-select.is-open').forEach((node) => {
        if (node !== wrap) node.querySelector('.fsp-custom-select__trigger')?.click();
      });
      const open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open);
      menu.hidden = !open;
      trigger.setAttribute('aria-expanded', String(open));
      if (open) {
        render();
        requestAnimationFrame(() => search.focus());
      }
    });
    search.addEventListener('input', render);
    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, { childList: true, subtree: true, attributes: true });
    document.addEventListener('click', (event) => { if (!wrap.contains(event.target)) close(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && wrap.classList.contains('is-open')) {
        close();
        trigger.focus();
      }
    });
    render();
  };
  document.querySelectorAll('[data-fsp-supply-fitment]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const variants = JSON.parse(root.querySelector('[data-variant-supply]').textContent);
    const productRoot = document.querySelector('[data-fsp-product]');
    const active = () => {
      const id = Number(productRoot?.querySelector('[name="id"]')?.value || variants[0]?.id);
      return variants.find((v) => v.id === id) || variants[0];
    };
    const card = root.querySelector('[data-supply-card]');
    const title = root.querySelector('[data-supply-title]');
    const copy = root.querySelector('[data-supply-copy]');
    const paintSupply = () => {
      const v = active(), stopped = ['discontinued', 'inactive'].includes(v?.status);
      card.classList.remove('is-supplier', 'is-unavailable', 'is-discontinued');
      if (stopped) {
        card.classList.add('is-discontinued'); title.textContent = 'Discontinued';
        copy.textContent = 'This part is no longer available from the supplier.';
      } else if (v?.available && v.quantity > 0) {
        title.textContent = 'In stock'; copy.textContent = 'Ready to order from current inventory.';
      } else if (v?.available) {
        card.classList.add('is-supplier'); title.textContent = 'Available from supplier';
        copy.textContent = 'Special-order item. Supplier availability and lead time are confirmed after your order.';
      } else {
        card.classList.add('is-unavailable'); title.textContent = 'Currently unavailable';
        copy.textContent = 'Contact us to confirm availability or an alternative part.';
      }
    };
    productRoot?.addEventListener('change', () => setTimeout(paintSupply));
    paintSupply();

    const form = root.querySelector('[data-fitment-picker]');
    if (!form) return;
    const apiA = root.dataset.apiA.replace(/\/$/, '');
    const apiB = root.dataset.apiB.replace(/\/$/, '');
    const apiForYear = (year) => Number(year) < 2000 ? apiA : apiB;
    const names = ['year', 'make', 'model', 'submodel'];
    const fields = Object.fromEntries(names.map((n) => [n, form.elements[n]]));
    Object.values(fields).forEach(enhanceSelect);
    const submit = form.querySelector('[type="submit"]');
    const resultCard = root.querySelector('[data-fitment-card]');
    const resultTitle = root.querySelector('[data-fitment-title]');
    const resultCopy = root.querySelector('[data-fitment-copy]');
    const clear = root.querySelector('[data-fitment-clear]');
    const populate = (name, values) => {
      fields[name].innerHTML = `<option value="">Select ${name}</option>`;
      values.forEach((v) => fields[name].add(new Option(v, v)));
      fields[name].disabled = false;
    };
    const load = (name) => {
      const p = new URLSearchParams();
      names.slice(0, names.indexOf(name)).forEach((n) => p.set(n, fields[n].value));
      if (name === 'year') {
        return Promise.all([apiA, apiB].map((base) => getJSON(`${base}/options?field=year`)))
          .then((responses) => [...new Set(responses.flatMap((data) => data.options || []))]
            .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })))
          .then((values) => populate(name, values));
      }
      p.set('field', name);
      return getJSON(`${apiForYear(fields.year.value)}/options?${p}`).then((d) => populate(name, d.options || []));
    };
    names.slice(0, -1).forEach((name, i) => fields[name].addEventListener('change', () => {
      names.slice(i + 1).forEach((n) => {
        fields[n].innerHTML = `<option value="">Select ${n}</option>`; fields[n].disabled = true;
      });
      submit.disabled = true;
      if (fields[name].value) load(names[i + 1]).catch(() => { resultCopy.textContent = 'Vehicle data is temporarily unavailable.'; });
    }));
    fields.submodel.addEventListener('change', () => { submit.disabled = !fields.submodel.value; });
    const show = (answer, vehicle) => {
      resultCard.classList.remove('is-fit', 'is-no-fit', 'is-unverified');
      form.hidden = true; clear.hidden = false;
      if (answer.fit === true) {
        resultCard.classList.add('is-fit'); resultTitle.textContent = 'Fits your vehicle';
        resultCopy.textContent = `${answer.product_type || 'This part'} fits ${vehicle.label}.`;
      } else if (answer.fit === false) {
        resultCard.classList.add('is-no-fit'); resultTitle.textContent = 'Does not fit your vehicle';
        resultCopy.textContent = `No verified fitment was found for ${vehicle.label}.`;
      } else {
        resultCard.classList.add('is-unverified'); resultTitle.textContent = 'Fitment not verified';
        resultCopy.textContent = 'We do not have enough data to confirm this configuration. Contact our fitment team before ordering.';
      }
    };
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const vehicle = Object.fromEntries(names.map((n) => [n, fields[n].value]));
      vehicle.label = names.map((n) => vehicle[n]).join(' ');
      const q = new URLSearchParams({ sku: active()?.sku || '', ...vehicle });
      submit.disabled = true;
      getJSON(`${apiForYear(vehicle.year)}/check?${q}`).then((a) => {
        localStorage.setItem(savedKey, JSON.stringify(vehicle)); show(a, vehicle);
      }).catch(() => show({ fit: null }, vehicle)).finally(() => { submit.disabled = false; });
    });
    clear.addEventListener('click', () => {
      form.hidden = false; clear.hidden = true;
      resultCard.classList.remove('is-fit', 'is-no-fit', 'is-unverified');
      resultTitle.textContent = 'Select your vehicle'; resultCopy.textContent = 'Choose your vehicle to verify that this part fits.';
    });
    const restoreVehicle = async (saved) => {
      if (!saved) return;
      for (let i = 0; i < names.length; i += 1) {
        const name = names[i];
        if (!saved[name]) return;
        fields[name].value = saved[name];
        if (i < names.length - 1) await load(names[i + 1]);
      }
      form.dispatchEvent(new Event('submit', { cancelable: true }));
    };
    load('year').then(() => restoreVehicle(JSON.parse(localStorage.getItem(savedKey) || 'null')))
      .catch(() => { resultCopy.textContent = 'Vehicle data is temporarily unavailable.'; });
    window.addEventListener('fsp:vehicle-saved', (event) => restoreVehicle(event.detail).catch(() => {}));
  });
})();
